import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Logo } from '../../shared/ui/components';

export function AuthLayout({ title, children, footer }: { title: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <main className="auth">
      <Link to="/" className="auth__logo" aria-label="Volver a la página principal">
        <Logo />
      </Link>
      <div className="auth__panel">
        <h1>{title}</h1>
        {children}
      </div>
      {footer ? <p className="auth__footer">{footer}</p> : null}
    </main>
  );
}
